import React, { useState } from 'react'
import Modal from 'react-modal'
import CreatableSelect from 'react-select/creatable'
import { Form, FormGroup, FormControl, ControlLabel, Col, Grid, Row } from 'react-bootstrap'
import { getModalStyles, getSubModalStyles } from '../../common/utils'
import { useSelector, useDispatch } from 'react-redux'
import { swalError, swalNotify } from '../../common/components/Swaler'
import { sendEasyAccesses } from '../../common/redux/collectionActions'

const NewEasyAccessModal = ({ closeModal }) => {
    const [receivers, setReceivers] = useState([] || [{ phone: "0709700362", name: "Robert", companyName: "Qlocx AB" }])
    const [selectedLock, setSelectedLock] = useState({})
    const [additinalInfo, setAdditionalInfo] = useState({})

    const dispatch = useDispatch()

    const locks = useSelector(s => s.collectionData.locks)
    const receiverList = locks.reduce((acc, val) => {
        if (Array.isArray(val.receiverList)) {
            for (const receiver of val.receiverList) {
                if (!acc.find(a => a.phone === receiver.phone)) acc.push(receiver)
            }
        }

        return acc
    }, [])

    const options = receiverList.map(receiver => {
        return { label: `${receiver.name} (${receiver.phone})${receiver.companyName ? ", " + receiver.companyName : ''}`, value: receiver.phone }
    })
    const addNewReceiverLabel = `* Lägg till ny mottagare`
    options.push({ label: addNewReceiverLabel })

    const loading = { createReceiver: false }

    const [createInput, setCreateInput] = useState(null)

    const addOrRemoveReceiver = (receiver) => {
        if (receiver) {
            setReceivers(receivers.filter(r => r.phone !== receiver.phone))
        } else {
            setReceivers(receivers.concat(createInput))
        }
    }

    const addReceiver = () => {
        const { phone, name, companyName } = createInput
        const cleanedPhone = phone.split('').filter(f => f <= "9" && f >= "0").join('')
        if (!phone || cleanedPhone.length < 9 || phone.length < 9) return swalError("Vänligen fyll i ett mobiltelefonnummer")
        if (!name) return swalError("Vänligen fyll i personens namn")

        setReceivers(receivers.concat(createInput))
        setCreateInput(null)
    }

    const send = () => {
        if (!receivers.length) return swalError("Vänligen ange mottagare")
        if (!selectedLock) return swalError("Vänligen ange en mottagarenhet")

        dispatch(sendEasyAccesses(receivers, selectedLock._id, additinalInfo)).then(t => {
            swalNotify(`${receivers.length > 1 ? 'Gästnycklar' : 'Gästnyckel'} har skickats ut`, '', 'Ok')
            closeModal()
        })
    }

    const didSelectReceiver = (receiver) => {
        if (!receivers.find(r => r.phone === receiver.phone)) setReceivers(receivers.concat(receiver))
    }

    return (
        <Modal
            ariaHideApp={false}
            isOpen={true}
            onRequestClose={() => closeModal()}
            style={getModalStyles(0.7)}>

            <div className="qCloseButton" onClick={() => closeModal()}>Stäng</div>

            <div>
                <div className="cluster-box-modal-close" onClick={() => closeModal()}>X</div>

                <br />
                <br />

                <Grid fluid>
                    <Row>
                        <Col sm={12} xs={12} md={12} lg={12}>
                            <div style={{ width: "100%", marginBottom: 10 }} className="userFormAccessTitle">
                                Vilka ska få gästnycklar?
                            </div>
                        </Col>
                    </Row>
                    <Row>
                        <Col sm={12} xs={12} md={6} lg={6}>
                            <CreatableSelect
                                isClearable
                                value={null}
                                onChange={(o) => { if (!o) return; o.label === addNewReceiverLabel ? setCreateInput({}) : didSelectReceiver(receiverList.find(r => r.phone === o.value)) }}
                                onCreateOption={(name) => setCreateInput(createInput ? { ...createInput, name } : { name })}
                                options={options}
                                placeholder="Ange personens namn"
                                formatCreateLabel={(inputText) => `Lägg till "${inputText}"`}
                            />
                        </Col>
                        <Col sm={12} xs={12} md={6} lg={6}>
                            <input type="checkbox" defaultChecked={true} onChange={e => setAdditionalInfo({ ...additinalInfo, unlimitedUses: e.target.checked })} id="oneTime" />
                            <label for="oneTime">Engångsnyckel</label> (tillgång till enheten vid ett tillfälle)
                        </Col>
                    </Row>
                </Grid>

                {createInput !== null ?
                    <div>
                        <Modal
                            ariaHideApp={false}
                            isOpen={true}
                            onRequestClose={() => setCreateInput(null)}
                            style={getSubModalStyles()}>

                            <div className="qCloseButton" onClick={() => setCreateInput(null)}>Stäng</div>
                            <h4 style={{ textAlign: 'left' }}>Registrera ny mottagare</h4>
                            <Form horizontal>
                                <FormGroup>
                                    <Col componentClass={ControlLabel} md={3} lg={3} sm={12}>
                                        Namn
                                        </Col>
                                    <Col md={9} lg={9} sm={12}>
                                        <FormControl type="text" placeholder="Ex: Robert" value={createInput.name} onChange={e => setCreateInput({ ...createInput, name: e.target.value })} />
                                    </Col>
                                </FormGroup>
                                <FormGroup>
                                    <Col componentClass={ControlLabel} md={3} lg={3} sm={12}>
                                        Mobil
                                        </Col>
                                    <Col md={9} lg={9} sm={12}>
                                        <FormControl type="text" placeholder="Ex: 0709700362" value={createInput.phone || ''} onChange={e => setCreateInput({ ...createInput, phone: e.target.value })} />
                                    </Col>
                                </FormGroup>
                                <FormGroup>
                                    <Col componentClass={ControlLabel} md={3} lg={3} sm={12}>
                                        Företag
                                        </Col>
                                    <Col md={9} lg={9} sm={12}>
                                        <FormControl type="text" placeholder="Ex: Qlocx AB" value={createInput.companyName || ''} onChange={e => setCreateInput({ ...createInput, companyName: e.target.value })} />
                                    </Col>
                                </FormGroup>
                            </Form>

                            <br />

                            <button className="qSaveButton" style={{ width: "20%", marginLeft: "40%" }} onClick={addReceiver}>{loading.createReceiver ? 'Loading...' : 'Spara'}</button>
                        </Modal>
                    </div>
                    : null
                }


                <div>
                    <Grid fluid>
                        {receivers.length ?
                            <div style={{ marginTop: 30, textAlign: 'left' }}>
                                <Row>
                                    <Col xs={12} sm={5} md={3} lg={3}>
                                        <h5 style={{ color: '#006e78' }}>Telefonnummer</h5>
                                    </Col>
                                    <Col xs={12} sm={5} md={3} lg={3}>
                                        <h5 style={{ color: '#006e78' }}>Namn</h5>
                                    </Col>
                                    <Col xs={12} sm={5} md={3} lg={3}>
                                        <h5 style={{ color: '#006e78' }}>Företag</h5>
                                    </Col>
                                    <Col xs={12} sm={5} md={3} lg={3}>
                                        &nbsp;
                                    </Col>
                                </Row>

                                {receivers.map((receiver, i) => {
                                    if (!receiver) return null

                                    return (
                                        <Row key={i}>
                                            <Col xs={12} sm={12} md={3} lg={3}>
                                                {receiver.phone}
                                            </Col>
                                            <Col xs={12} sm={12} md={3} lg={3}>
                                                {receiver.name}
                                            </Col>
                                            <Col xs={12} sm={12} md={3} lg={3}>
                                                {receiver.companyName}
                                            </Col>
                                            <Col xs={12} sm={12} md={1} lg={1}>
                                                <div className="qCloseButton" onClick={() => addOrRemoveReceiver(receiver)}>X</div>
                                            </Col>
                                        </Row>
                                    )
                                })}
                            </div>
                            : null}
                    </Grid>
                </div>

                <br />
                <br />

                <div className="container-fluid">
                    <div style={{ width: "100%" }} className="userFormAccessTitle">
                        Vilken enhet vill du bjuda in till?
                    </div>

                    {locks.map((lock, i) => {
                        const isSelected = selectedLock._id === lock._id

                        return (
                            <div key={i} lg={12} xs={12} style={{ display: 'flex', backgroundColor: isSelected ? '#006e78' : 'white', color: isSelected ? 'white' : 'black' }} className="qBigBtn" onClick={() => setSelectedLock(lock)}>
                                <div style={{ width: '30%' }}>
                                    Välj
                                </div>

                                <div style={{ width: "70%", textAlign: 'left' }}>
                                    {lock.custom_name}, {lock.address.street} {lock.address.city}
                                </div>
                            </div>
                        )
                    })}
                </div>

                <br />
                <br />

                <div>
                    <div className="submitUserForm" onClick={send}>Skicka</div>
                </div>
            </div>
        </Modal >
    )
}

export default NewEasyAccessModal
